import { ExtractPropTypes, PropType } from 'vue'

export type ParamDir = 'v' | 'vo' | ''

export const paramProps = {
	data: {
		type: [Array, String] as PropType<Array<{ label: string; value: string; merge: number | string }> | string>,
		default: () => []
	},
	// label 的宽度
	// '' 自动宽度
	// compute 取最长的 label 的宽度
	// 1-20
	labelWidth: {
		type: [String, Number] as PropType<string | number>,
		default: ''
	},
	dir: {
		type: String as PropType<ParamDir>,
		default: ''
	},
	// 分列的列数
	col: {
		type: [String, Number] as PropType<string | number>,
		default: ''
	},
	mode: {
		type: String,
		default: ''
	},
	type: {
		type: String,
		default: ''
	},
	align: {
		type: String,
		default: ''
	},
	// 是否平均分布
	avg: {
		type: Boolean,
		default: false
	},
	/**
	 * 文字过长时是否换行显示
	 */
	wrap: {
		type: Boolean,
		default: false
	},
	tip: {
		type: Boolean,
		default: false
	},
	flex: Boolean
}

export type ParamProps = ExtractPropTypes<typeof paramProps>
